/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2017, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'../../lib/@waca/core-client/js/core-client/ui/core/Class'
], function (Class) {

	'use strict';

	const SmartsRecommenderService = Class.extend({

		init: function(options){
			SmartsRecommenderService.inherited('init', this, arguments);
			this.ajaxSvc = options.ajaxSvc;
			this.logger = options.logger;
		},

		destroy: function() {
			this.ajaxSvc = null;
			this.logger = null;
		},

		_executeRequest: function(data, requestURL){
			const querySpec = JSON.stringify(data);
			const requestPayload = {
				type: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				data: querySpec,
				processData: false,
				url: requestURL
			};

			return this.ajaxSvc.ajax(requestPayload)
				.then(ajaxResponse => {
					return Promise.resolve(ajaxResponse);
				});
		}
	});

	return SmartsRecommenderService;
});
